import { useTranslate } from "react-admin";

import WalletRiskLevelRescanStatus from "@wallet-manager/node-types/dist/types/postgres/const/WalletRiskLevelRescanStatus";

// Text colors per status. Picked to match the existing risk-level badge's
// palette so the two side-by-side reads look like one design system:
//   * Failed   → red      (Ant Design red 7)
//   * Pending  → blue     (Ant Design blue 7)
//   * Applied  → green    (Ant Design green 7)
//   * Expired  → gray     (Ant Design gray 7)
// Unknown / unmapped values fall back to the default text color.
const STATUS_COLOR: Record<number, string> = {
  [WalletRiskLevelRescanStatus.Failed]: "#CF1322",
  [WalletRiskLevelRescanStatus.Pending]: "#0958D9",
  [WalletRiskLevelRescanStatus.Applied]: "#237804",
  [WalletRiskLevelRescanStatus.Expired]: "#0958D9",
};

const colorForStatus = (status: number | string | null | undefined): string => {
  const numeric = Number(status);
  return STATUS_COLOR[numeric] ?? "#262626";
};

interface StatusBadgeProps {
  status: number | string | null | undefined;
}

// Translate the numeric status coming back from the API into the matching
// `WalletRiskLevelRescanStatus` enum name and render it with the matching
// status color. Used by both the Risk Checking Record table's Outcome
// column and the Provider Response dialog's outcome row.
const StatusBadge = ({ status }: StatusBadgeProps) => {
  const translate = useTranslate();
  const numeric = Number(status);

  // `WalletRiskLevelRescanStatus[-1] === "Failed"` — the reverse mapping
  // on a numeric enum gives us the enum name from its value.
  const enumName = WalletRiskLevelRescanStatus[numeric];
  const label =
    enumName !== undefined
      ? translate(`enumConstants.RescanStatus_${enumName}`)
      : status
      ? String(status)
      : "—";

  return (
    <span
      style={{
        color: colorForStatus(status),
        fontWeight: 500,
      }}
    >
      {label}
    </span>
  );
};

export default StatusBadge;
